"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productShadesQuery = void 0;
var _fetching = require("@ori/fetching");
const productShadesQuery = exports.productShadesQuery = (0, _fetching.gql)`
  query ProductShades($productCode: ID!) {
    product(productCode: $productCode) {
      concept {
        products {
          colorImageUrl
          hexColors
          labels {
            labelKey
          }
          productCode
          shadeName
        }
      }
    }
  }
`;
